import { Func1 } from "../_utils/fnTypes";
import { IScrollContainerProps } from "../scroll/perfectScrollModel";

export function getScrollContainerProps(
    element: HTMLElement,
    getScrollContainerProps: Func1<HTMLElement, IScrollContainerProps>
) {
    const rect = element.getBoundingClientRect();
    return {
        containerWidth: Math.round(rect.width),
        containerHeight: Math.round(rect.height),
        ...(getScrollContainerProps ?? getScrollContainerPropsFromHTMLElement)(
            element
        ),
    };
}

const getScrollContainerPropsFromHTMLElement: Func1<
    HTMLElement,
    IScrollContainerProps
> = element => ({
    contentWidth: element.scrollWidth,
    contentHeight: element.scrollHeight,
    scrollTop: element.scrollTop,
    scrollLeft: element.scrollLeft,
});
